import styled from "styled-components";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import { regular as regularFontWeight } from "core/fontStyles";

// components
import { TagWrapper } from "frontend/components/core/Tag/styles.js";

// styled-components
export const AddTagStyled = styled.div`
    margin-bottom: ${convertPxToRem(24)};
`;
export const InputWithIconWrapperStyled = styled.div`
    margin-bottom: ${convertPxToRem(8)};
`;

export const TagListStyled = styled.div`
    margin-bottom: ${convertPxToRem(24)};

    h4 {
        margin-bottom: ${convertPxToRem(16)};
    }
`;
export const TagListItemStyled = styled.div`
    ${regularFontWeight}
    display: flex;
    align-items: center;
    margin-bottom: ${convertPxToRem(8)};
`;

export const CheckboxStyled = styled.div`
    flex: 0 0 ${convertPxToRem(22)};
`;
export const TagStyled = styled.div`
    flex: 1;

    ${TagWrapper} {
        margin-bottom: 0px;
    }
`;
